// MST
import { types } from 'mobx-state-tree'

// Types
const { model, optional, boolean } = types

// Base Model
const GeneralStoreModel = model('General')
  .props({
    general_isOnline: optional(boolean, true),
    general_isReconnected: optional(boolean, false),
  })
  .actions(self => ({
    general_SET_ONLINE: (payload: boolean) => {
      self.general_isOnline = payload
      self.general_isReconnected = payload
    },
  }))

export const createGeneralStoreDefaultModel = () => optional(GeneralStoreModel, {})
